import React from "react";

function UserAdminPage(props) {
  return <div>User Admin Page</div>;
}

export default UserAdminPage;
